export default __webpack_public_path__ + "static/media/feather_trash-2.6402fe89.svg";